<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Planogram Problems</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="close()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body p-3">
  <ng-container *ngIf="problemTypes.length > 0; else noProblems">
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li *ngFor="let problemType of problemTypes" [ngbNavItem]="problemType">
        <a ngbNavLink>{{ problemType }}</a>
        <ng-template ngbNavContent>
          <div class="alert alert-warning mt-3 mb-3" *ngIf="getProblemMessage(problemType) as message">
            {{ message }}
          </div>
          <div class="table-responsive" style="max-height: 30vh;">
            <table class="table table-bordered mb-0">
              <thead>
                <tr>
                  <th>Product ID</th>
                  <th>Barcode</th>
                  <th>{{ problemType === PlanogramProblemType.MissingImages ? 'Orientation' : 'Brand' }}</th>
                  <th>Description</th>
                  <th *ngIf="problemType === PlanogramProblemType.MissingImages || problemType === PlanogramProblemType.MissingDimensions">OnQR Capture</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let product of planogramProblemsService.problems.get(problemType)">
                  <td>{{ product.productId }}</td>
                  <td>{{ product.barcode }}</td>
                  <td>{{ problemType === PlanogramProblemType.MissingImages ? ProductOrientation[product.orientation] : product.brand }}</td>
                  <td>{{ product.description }}</td>
                  <td *ngIf="problemType === PlanogramProblemType.MissingImages || problemType === PlanogramProblemType.MissingDimensions">
                    <button type="button" class="btn btn-sm w-100"
                            [class.btn-outline-primary]="!product.captureRequired"
                            [class.btn-secondary]="product.captureRequired"
                            [disabled]="product.captureRequired"
                            (click)="flagProduct(product)">
                      {{ product.captureRequired ? 'Flagged' : 'Flag' }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </ng-container>

  <ng-template #noProblems>
    <p class="lead text-success mb-0 text-center">✅ No problems detected.</p>
  </ng-template>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="close()">Close</button>
</div>